import { Step } from 'react-joyride';

// Library/Documents page controlled tour steps
export const librarySteps: Step[] = [
  {
    target: '.library-page-header',
    title: 'Welcome to Company Directory',
    content:
      'This is your document hub where you can access all franchise-related documents, contacts, and resources shared by your franchisor.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.library-main-tabs',
    title: 'Main Navigation Tabs',
    content:
      'Switch between Documents (shared files and uploads) and Franchise Contacts (team directory and contact information).',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.library-documents-tab',
    title: 'Documents Section',
    content:
      'Access all your franchise documents including shared files from your franchisor, training materials, and important resources.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.library-contacts-tab',
    title: 'Franchise Contacts',
    content:
      'Find contact information for your franchise support team, leadership, and other key personnel to help you succeed.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.documents-table',
    title: 'Document Management',
    content:
      'View, download, and manage your documents. Each document shows its name, file details, and actions you can perform like downloading or viewing.',
    placement: 'top',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
];
